import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-registration-filter',
  templateUrl: './registration-filter.component.html',
  styleUrls: ['./registration-filter.component.css']
})
export class RegistrationFilterComponent {
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  @Input() valStatusList: any = [];
  @Input() langInList: any = [];
  @Input() contestSourcesList: any = [];
  @Input() contestStatusesData: any = [];
  @Input() filterData: any = {};

  /* sourceInStatusList = [
    { id: 1, name: "WB", label: "Web"},
    { id: 2, name: "WA", label: "Whatsapp"},
    { id: 3, name: "IVR", label: "IVR"},
  ] */
  RegInStatusList = [
    { id: 1, name: "SUBMITTED", label: "Submitted"},
    { id: 2, name: "DRAFT", label: "Draft"},
  ]

  filterForm: any = FormGroup;
  defaultFilterValues: any = {
    stDtGrEq: "",
    enDtLsEq: "",
    valStatus : "",
    langIn: "",
    statusIn: "",
    sourceIn: ""
  }
  filterDataObj = {};
  uiPrivileges: any = {};

  constructor(private fb: FormBuilder,) {
    this.filterForm = this.fb.group(this.defaultFilterValues);
    let _uiPrivilege = localStorage.getItem("uiPrivileges")
    this.uiPrivileges = _uiPrivilege && JSON.parse(_uiPrivilege);
  }

  ngOnInit() {
    // console.log(this.filterData, "filterData received")
    
    if (this.filterData.stDtGrEq && this.filterData.enDtLsEq) {
      this.filterForm.get("stDtGrEq").setValue(this.filterData.stDtGrEq)
      this.filterForm.get("enDtLsEq").setValue(this.filterData.enDtLsEq)
    }
    if (this.filterData.valStatus) {
      this.filterForm.get("valStatus").setValue(this.filterData.valStatus);
    }
    if (this.filterData.langIn) {
      this.filterForm.get("langIn").setValue(this.filterData.langIn);
    }
    if (this.filterData.statusIn) {
      this.filterForm.get("statusIn").setValue(this.filterData.statusIn);
    }
    if (this.filterData.sourceIn) {
      this.filterForm.get("sourceIn").setValue(this.filterData.sourceIn);
    }
   
  }


  cancelClick() {
    this.cancel.emit();
  }

  async onSubmit() {
    let filter = {
      stDtGrEq: this.filterForm.get("stDtGrEq").value,
      enDtLsEq: this.filterForm.get("enDtLsEq").value,
      valStatus: this.filterForm.get("valStatus").value,
      langIn: this.filterForm.get("langIn").value,
      statusIn: this.filterForm.get("statusIn").value,
      sourceIn: this.filterForm.get("sourceIn").value,
    }
    this.filterDataObj = filter;

    // console.log(filter, "filter")

    this.passEntry.emit({
      data: this.filterDataObj
    });
  }

  async closeModal() {
    this.close.emit();
  }
 
  async filterReset() {
    this.filterForm.get("stDtGrEq").setValue("")
    this.filterForm.get("enDtLsEq").setValue("")
    this.filterForm.get("valStatus").setValue("");
    this.filterForm.get("langIn").setValue("")
    this.filterForm.get("statusIn").setValue("")
    this.filterForm.get("sourceIn").setValue("")

  }
}
